import React from 'react';
import Nailserice from '../assets/nailser.jpeg';
import waxtreatment from '../assets/waxtreatment.jpg';
import eyebrowwax from '../assets/eyebrowwax.jpg';
import fullbodywax from '../assets/fullbody.jpg';
import './Service.css';


const Waxing = () => {
  return (
    <>

<div class="homepageimg">
        <img src={Nailserice} alt="Beauty Destination" class="full-screen-image bgimg" />
   </div>
<div class="d-flex justify-content-center pt-5">
  <h1 style={{ color: '#b37777', fontStyle: 'italic', fontFamily: "'TAN TWINKLE', cursive" }}>Waxing</h1>
</div>
   <div class="container pt-4">
    <div class="row align-items-center  animate-form servicecontainer">
        <div class="col-sm-6">
            <img src={waxtreatment} alt="Nail Services" style={{width: "100%", height: "500px"}} />
        </div>
        <div class="col-sm-6">
          <h1 class="service-header text-center pt-2">Full Face Wax</h1>
          <p>
            Get flawless, hair-free skin with our full face waxing treatment. Removes unwanted facial 
            hair for smooth, radiant results that last longer. Perfect for a polished, glowing complexion!
            </p>            
            <p class="service-price"><strong>Pricing:</strong> Starts from $XX</p>
      </div>
    </div>
    <div class="row align-items-center  animate-form1 servicecontainer">
     
      <div class="col-sm-6">
        <h1 class="service-header text-center">Eyebrow Wax & Shapes</h1>
        <p>
          Transform your brows with our precision Eyebrow Wax & Shape. Get beautifully defined, 
          well-shaped eyebrows that frame your face and enhance your natural features. 
          Perfect for a clean, polished, and effortlessly chic look.        
         </p>
        <p class="service-price"><strong>Pricing:</strong> Starts from $XX</p>
    </div>
     
    <div class="col-sm-6">
      <img src={eyebrowwax} alt="Nail Services" style={{width: "100%", height: "500px"}} />
  </div>
  </div>
  <div class="row align-items-center  animate-form servicecontainer">
   
    <div class="col-sm-6">
        <img src={fullbodywax} alt="Nail Services" style={{width: "100%", height: "500px"}} />
    </div>
    <div class="col-sm-6">
      <h1 class="service-header text-center pt-2">Full Body Wax</h1>
      <p>
        Experience the luxury of silky-smooth skin with our full body wax. Perfect for a long-lasting, 
        hair-free result that leaves you feeling refreshed and confident. Get ready to glow!   
        </p> 
        </div>
</div>
</div>



    
    </>
  )
}
export default Waxing;

